import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export interface ITraderMapCampaign {
    id: string
    project_id?: string
    banner_id?: {
        en: string
        ko: string
    }
    title?: {
        en: string
        ko: string
    }
    description?: {
        en: string
        ko: string
    }
    symbol: string
    priority: number
    status: string
    symbol_image?: string
    exchanges: {[key: string]: string}
    start_at: string
    end_at: string
    prize_pool?: {
        total_amount: number
        currency: string
    }
    url_third_party?: string
    created_at: string
    updated_at: string
}

export const getTraderMapCampaigns = async (active?: boolean): Promise<ApiRes<ITraderMapCampaign[]>> => {
    return await apiGet(API_URL, `admin/trader/campaigns`)
}
